<template>
    <div class="accessIndex">

      <div class="accessIndex__reload">
        <p class="accessIndex__text--title_access">
          Locaciones
        </p>
        <v-hover>
          <div
            @click="findLocations();date_available=false;"
            slot-scope="{ hover }"
            class="accessIndex__reload--container_access"
            :class="hover?'accessIndex__interaction--hover':''"  >
            <img src="../../../assets/img/reload_blue.svg">
          </div>
        </v-hover>
      </div>


      <div class="accessIndex__locations">
        <div
          class="accessIndex__locations--item_access"
          v-for="location in new_locations" :key="location.id"
          @click="$router.push({ name:'EventReports', params: {id: location.id, filter: true, namex:location.title, date: date,date2:date } })">
          <div class="accessIndex__locations--item_info">
            <div class="accessIndex__text--small_left">
              <p>{{location.name}}</p>
            </div>

          </div>
        </div>
        <div class="table_card__footer">
          <nav class="pagination" role="navegation" aria-label="pagination">
            <v-pagination
              :value ="page"
              :length="pages"
              @input ="changePage"
            />
          </nav>
        </div>
      </div>


    </div>
</template>

<script>
export default {
  data(){
    return{
      date_available:false,
      new_locations: [],
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      myRequestInterval:null,
      page: 1,
      pages: 1,

    }
  },

  methods:{

    findLocations(){

      try {
        const data={company_id:this.getCompany().id}
        this.$http.post('alarm/get_locations',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params:{
            page: this.page
          }
        })
        .then(function(response){
            console.log('response.body.data', response.body.data)

            this.pages = response.data.pages
            this.new_locations = response.body.data
        }, function(response){
           
        })
      } catch (e) {
        alert(e.message)
      }
    },


    changePage (page){
      console.log('====logPage=====')
      console.log(page)
      this.page = page
      this.findLocations();
    }

  }, /* closed methods */
  mounted(){
    this.findLocations();
    var vm = this;
    this.myRequestInterval=setInterval(function(){
    //     /* Actualiza cada 5 minutos */
        vm.findLocations();
    },300*1000);
  },
  beforeDestroy(){
    clearInterval(this.myRequestInterval)
  }

}
</script>



// WEBPACK FOOTER //
// src/components/views/alarms/Index.vue